import styled from "styled-components";
import { devices } from "../../../Devices";

export const Container = styled.div`
  padding: 2rem 3.6rem;
  min-height: 100vh;
  background: #fff;
  @media ${devices.mobileL} {
    padding: 1rem 0.5rem;
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: start;
`;

export const Title = styled.h1`
  font-size: 2.4rem;
  font-weight: 600;
  margin: 2.5rem 0 1.5rem 0;
  text-align: center;
  color: #22223b;
  @media ${devices.mobileL} {
    font-size: 1.6rem;
    margin: 1.5rem 0 1rem 0;
  }
`;

export const Pagination = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0;
  gap: 1rem;
`;

export const PageButton = styled.button`
  background: #fbf1e6;
  color: #22223b;
  border: none;
  border-radius: 0.5rem;
  padding: 0.5rem 1.2rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #fbbf24;
  }
  &:disabled {
    background: #eaeaea;
    color: #aaa;
    cursor: not-allowed;
  }
`;
